/* eslint-disable trane/enforce-exports */
import type { Data } from 'plotly.js'
import _ from 'underscore'
import type {
  ColorType,
  ConsumerRTHSeries,
  ConsumerRTHState,
} from '../../../../themes'

export const plotConsumerRTHData = (
  data: Array<ConsumerRTHSeries & { state: ConsumerRTHState }> | undefined,
  colors: ColorType,
) => {
  if (!data) return []

  const coolData = _.find(data, (series) => series.state === 'cool')
  const coolStage2Data = _.find(
    data,
    (series) => series.state === 'cool_stage2',
  )
  const heatAuxData = _.find(data, (series) => series.state === 'heat_aux')
  const heatAuxStage2Data = _.find(
    data,
    (series) => series.state === 'heat_aux_stage2',
  )
  const heatAuxStage3Data = _.find(
    data,
    (series) => series.state === 'heat_aux_stage3',
  )
  const heatData = _.find(data, (series) => series.state === 'heat')
  const heatStage2Data = _.find(
    data,
    (series) => series.state === 'heat_stage2',
  )
  const heatStage3Data = _.find(
    data,
    (series) => series.state === 'heat_stage3',
  )

  const colorLookup = (stateName: ConsumerRTHState) => {
    const COLOR_LOOKUP = {
      cool: colors.consumerRTH.cool as string,
      cool_stage2: colors.consumerRTH.coolStage2 as string,
      heat: colors.consumerRTH.heat as string,
      heat_stage2: colors.consumerRTH.heatStage2 as string,
      heat_stage3: colors.consumerRTH.heatStage3 as string,
      heat_aux: colors.consumerRTH.heatAux as string,
      heat_aux_stage2: colors.consumerRTH.heatAuxStage2 as string,
      heat_aux_stage3: colors.consumerRTH.heatAuxStage3 as string,
    }
    return COLOR_LOOKUP[stateName]
  }

  const plotData = [] as Data[]

  if (heatData) {
    plotData.push({
      y: heatData.data,
      name: heatData.name,
      type: 'bar',
      width: 0.5,
      marker: {
        color: colorLookup(heatData.state),
      },
      hoverinfo: 'none',
    })
  }
  if (heatStage2Data) {
    plotData.push({
      y: heatStage2Data.data,
      name: heatStage2Data.name,
      type: 'bar',
      width: 0.5,
      marker: {
        color: colorLookup(heatStage2Data.state),
      },
      hoverinfo: 'none',
    })
  }
  if (heatStage3Data) {
    plotData.push({
      y: heatStage3Data.data,
      name: heatStage3Data.name,
      type: 'bar',
      width: 0.5,
      marker: {
        color: colorLookup(heatStage3Data.state),
      },
      hoverinfo: 'none',
    })
  }
  if (heatAuxData) {
    plotData.push({
      y: heatAuxData.data,
      name: heatAuxData.name,
      type: 'bar',
      width: 0.5,
      marker: {
        color: colorLookup(heatAuxData.state),
      },
      hoverinfo: 'none',
    })
  }
  if (heatAuxStage2Data) {
    plotData.push({
      y: heatAuxStage2Data.data,
      name: heatAuxStage2Data.name,
      type: 'bar',
      width: 0.5,
      marker: {
        color: colorLookup(heatAuxStage2Data.state),
      },
      hoverinfo: 'none',
    })
  }
  if (heatAuxStage3Data) {
    plotData.push({
      y: heatAuxStage3Data.data,
      name: heatAuxStage3Data.name,
      type: 'bar',
      width: 0.5,
      marker: {
        color: colorLookup(heatAuxStage3Data.state),
      },
      hoverinfo: 'none',
    })
  }
  if (coolData) {
    plotData.push({
      y: coolData.data,
      name: coolData.name,
      type: 'bar',
      width: 0.5,
      marker: {
        color: colorLookup(coolData.state),
      },
      hoverinfo: 'none',
    })
  }
  if (coolStage2Data) {
    plotData.push({
      y: coolStage2Data.data,
      name: coolStage2Data.name,
      type: 'bar',
      width: 0.5,
      marker: {
        color: colorLookup(coolStage2Data.state),
      },
      hoverinfo: 'none',
    })
  }
  return plotData
}
